import React from 'react';
export function Footer() {
  return <footer className="bg-base border-t border-border-base mt-20" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-24">
          <div data-id="element-25">
            <h3 className="font-display text-2xl font-bold text-primary mb-2" data-id="element-26">
              Tuesday
            </h3>
            <p className="text-muted text-sm" data-id="element-27">
              Liveband aus Kempten im Allgäu. Live-Covers, eigene Produktionen
              und ein bühnenfertiger Sound.
            </p>
          </div>

          <div data-id="element-28">
            <h4 className="font-semibold text-primary mb-3" data-id="element-29">Kontakt</h4>
            <a href="mailto:booking@tuesday-band.de" className="text-muted hover:text-accent transition-colors text-sm" data-id="element-30">
              booking@tuesday-band.de
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border-base text-center text-muted text-sm" data-id="element-31">
          © {new Date().getFullYear()} Tuesday. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>;
}